<template>
  <transition name="modal">
    <div :class="['modal-mask', className || '']">
        <div class="modal-overlay" @click="$emit('close')"></div>
      <div class="modal-wrapper">
        <div class="modal-container">
          <button class="modal-close-btn" type="button" @click="$emit('close')">
            <template v-if="isDesktop">
              x
            </template>
            <template v-else>
              schließen
              <i class="far fa-times-circle"></i>
            </template>
          </button>
          <div class="modal-content">
            <div class="modal-header">
              <slot name="header" />
            </div>
            <div class="modal-body">
              <slot name="body" />
            </div>
            <div class="modal-footer">
              <slot name="footer" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['className'],
  computed: {
    isDesktop() {
      return window.innerWidth > 990;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/vars";
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  transition: opacity 0.3s ease;

  &.widget-modal {

    height:auto;

    .modal-close-btn {
      right: -25px;
      top: -25px;

      @include breakpoint(fromgiant) {
        right:25px;
        top:25px;
      }
    }

    .modal-content {
      height:auto;
      max-height:100%;

      @media screen and (min-width:1200px) and (max-height:1100px) {
        height:100%;
        display:flex;
        align-items:center;
        justify-content: center;
      }

      .modal-body {
        @include breakpoint(fromgiant) {
          padding-top:100px;
        }
        @media (min-width:1200px) and (max-height: 1258px) {
          padding-top:30px;
        }
      }
    }
    .modal-wrapper {
      max-width:325px;
      max-height:1258px;
      top: 50%;
      transform: translate(-50%, -50%);

      @include breakpoint(frommediumlarge) {
        max-width: 745px;
      }

      @include breakpoint(fromgiant) {
        max-width:100%;
        height: 100%;
        padding:0;
      }
    }
    .modal-container {
      max-width:300px;
      padding-left:0;
      padding-right:0;
      padding-bottom:0;
      max-height:100vh;
      padding-top:0;

      @include breakpoint(frommediumlarge) {
        max-width: 720px;
      }
      @include breakpoint(fromgiant) {
        max-width:100%;
      }
      @include breakpoint(fromgiant) {
        height:100%;
        padding-bottom:30px;
      }
    }
  }
}

.modal-overlay {
    position:absolute;
    width:100vw;
    height:100vh;
    top:0;
    left:0;
}

.modal-wrapper {
  position: absolute;
  top: 3.125rem;
  left: 50%;
  width: 100%;
  max-width: 850px;
  padding: 0 1.25rem;
  transform: translate(-50%, 0);
}

.modal-container {
  position: relative;
  width: 100%;
  max-width: 810px;
  margin: 0 auto;
  padding: 80px 22px 65px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.33);
  transform:none;
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-content {
  max-height: 60vh;
//   max-width: 52.5rem;
  margin: 0 auto;
  overflow: auto;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-close-btn {
    right: 25px;
    top: 25px;
    border-radius: 50%;
    height: 46px;
    width: 46px;
    display: block;
    border:0.1rem solid $light-gray;;
    background-color:$white;
    padding:0;
    text-indent: -9999rem;
    box-shadow:0 0 1rem rgba($green,.3);
    position: absolute;
    z-index:10;

    @include breakpoint(frommediumlarge) {
      right:25px;
      top:25px;
    }

    &:before, &:after {
      content:'';
      display: block;
      position: absolute;
      width: 0.1rem;
      height: 30px;
      background: #3a3a3a;
      top:7px;
      left: 21px;
      transform: rotate(45deg)
    }

    &:after {
      transform:rotate(-45deg);
    }
}

@include breakpoint(fromgiant) {
  .modal-container {
    padding: 80px 72px 68px 72px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Modal.vue